import { DeleteIcon, IconType } from 'components/icons/icons'
import { useCallback } from 'react'
import styles from './info.module.scss'
import { OverlaySpinner } from 'components/Spinner'

type Props = {
	text?: string // either text or children should be provided
	additionalInfo?: string
	children?: React.ReactElement
	isDeletable?: boolean
	onDelete?(): void
	disabled?: boolean
	onClick?(): void
	isLoading?: boolean
	Icon?: IconType
}

export const Info = ({ text, additionalInfo, children, isDeletable, onDelete, disabled, onClick, isLoading, Icon }: Props) => {
	const onDeleteCallback = useCallback(
		(e) => {
			e.stopPropagation();
			onDelete && onDelete()
		},
		[onDelete]
	)

	return (
		<div className={`${styles.item} ${disabled ? styles.disabled : ''}`} onClick={onClick}>
			{Icon && <Icon className={styles.icon} width={12} height={12} fill='currentColor' />}
			<div>{text || children}</div>
			{additionalInfo && <div className={styles.additional_info}>{additionalInfo}</div>}
			{(isDeletable && !disabled) &&
				<DeleteIcon
					fill='currentColor'
					className={styles.delete_icon}
					width={10}
					height={10}
					onClick={onDeleteCallback}
				/>
			}
			{isLoading && <OverlaySpinner size={24} withBackground />}
		</div>
	)
}
